import { useNavigate } from 'react-router';
import { toast } from 'sonner';
import { EGDialog } from '@/components/eg/eg-dialog';
import useAuth from '@/hooks/useAuth';
import useUser from '@/hooks/useUser';
import { api } from '@/lib/api';
import { useUiStore } from '@/stores/ui';
import { useUserStore } from '@/stores/user';

interface EGSwitchOrgModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  switchToOrgId: string | null;
}

export function EGSwitchOrgModal({ open, onOpenChange, switchToOrgId }: EGSwitchOrgModalProps) {
  const navigate = useNavigate();
  const userStore = useUserStore();
  const uiStore = useUiStore();
  const { getRefreshedToken } = useAuth();
  const { setCurrentUserDataFromToken } = useUser();

  async function doSwitchOrg() {
    uiStore.setRequestPending('switchOrg');

    try {
      useUserStore.setState({ mostRecentLab: { LaboratoryId: null } });

      await api.users.updateUserLastAccessInfo(userStore.currentUserDetails.id!, switchToOrgId ?? undefined, undefined);

      await getRefreshedToken();
      await setCurrentUserDataFromToken();

      void navigate('/');

      setTimeout(() => {
        uiStore.incrementRemountAppKey();
        toast.success('You have switched organizations');
        uiStore.setRequestComplete('switchOrg');
      }, 100);
    } catch (e) {
      uiStore.setRequestComplete('switchOrg');
      toast.error('Failed to switch organization. Please try again.');
    }
  }

  const isPending = uiStore.isRequestPending('switchOrg');

  return (
    <EGDialog
      open={open}
      onOpenChange={onOpenChange}
      primaryMessage="Are you sure you would like to switch organizations?"
      secondaryMessage="You are about to switch organization accounts. Ensure all unsaved work is saved and reviewed before proceeding. Switching accounts may result in losing access to current session data or active tasks."
      actionLabel={isPending ? 'Switching...' : 'Continue'}
      cancelLabel="Cancel"
      buttonsDisabled={isPending}
      loading={isPending}
      onAction={doSwitchOrg}
    />
  );
}

export default EGSwitchOrgModal;
